import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { BackupPage } from './BackupPage';
import { LiquidNitrogenMaintenancePage } from './LiquidNitrogenMaintenancePage';

export function MaintenancePage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey = searchParams.get('tab') === 'backup' ? 'backup' : 'liquid-nitrogen';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => setSearchParams(key === 'backup' ? { tab: 'backup' } : {})}
      items={[
        {
          key: 'liquid-nitrogen',
          label: t('maintenance.liquidNitrogenTab'),
          children: <LiquidNitrogenMaintenancePage />,
        },
        {
          key: 'backup',
          label: t('maintenance.backupTab'),
          children: <BackupPage />,
        },
      ]}
    />
  );
}
